import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: '19vh',
    background: '#FFFFFF',
    overflowX: 'hidden',
    position: 'fixed',
    zIndex: '99',
  },
  devEnvBanner: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '22px',
    lineHeight: '22px',
    textAlign: 'center',
    background: '#F57C00',
    color: '#FFFFFF',
    fontSize: '12px',
    fontWeight: 'bold',
    letterSpacing: '1px',
    zIndex: '100',
  },
  image: {
    width: '12%',
    height: '70%',
    marginLeft: '4%',
  },
  menu: {
    display: 'flex',
    flexDirection: 'row',
    width: '55%',
    justifyContent: 'space-between',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '1%',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  icon: {
    fontSize: '50px',
    color: '#232d64',
    opacity: '100%',
  },
  linkHome: {
    fontSize: '15px',
    color: '#232d64',
    opacity: '100%',
    textDecoration: 'none',
    marginTop: '8%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    cursor: 'pointer',
  },
  link: {
    fontSize: '15px',
    color: '#000000',
    opacity: '56%',
    textDecoration: 'none',
    marginTop: '8%',
  },
  itemUser: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '3%',
    marginTop: '-2%',
  },
  iconUser: {
    fontSize: '75px',
    color: '#232d64',
    opacity: '100%',
  },
  name: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  linkName: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#232d64',
    opacity: '100%',
    textDecoration: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    cursor: 'pointer',
  },
  iconExpand: {
    fontSize: '15px',
    color: '#232d64',
    opacity: '100%',
    marginTop: '7%',
  },
  rootPopper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'space-between',
    justifyContent: 'space-between',
    paddingRight: '10px',
    paddingLeft: '10px',
    paddingBottom: '12px',
    paddingTop: '12px',
  },
  typography: {
    textDecoration: 'none',
    color: '#232d64',
  },
}));

export default useStyles;
